<template>
  <div></div>
</template>

<script>
export default {
  name: "Irelmi",
  created() {
    window.open('https://kartazhizni.ru/eplontersen', "_self")
  }
}
</script>

<style lang="scss" scoped></style>